import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import IPropTypes from 'react-immutable-proptypes'
import _ from 'lodash'
import log from 'loglevel'

import config from '../../config'

import hocConnect from './hocConnect'

import './style.scss'

const dialogDiv = document.getElementById('dialog')
if (!dialogDiv) log.warn('You must define dialog element with id #dialog !')

const contentsPath = config.components.dialog.contentsPath
const contentComponents = _.mapValues(
    config.components.dialog.contents,
    (value) =>
        // eslint-disable-next-line import/no-dynamic-require, global-require
        require(`../../${contentsPath}${value.component}`).default
)

@hocConnect
export default class Dialog extends Component {
    static propTypes = {
        dialogs: IPropTypes.map.isRequired,
    }

    renderDialogs = () => {
        const { dialogs } = this.props

        return dialogs
            .valueSeq()
            .map((dialog) => {
                const ContentComponent = contentComponents[dialog.get('type')]

                return (
                    <div key={dialog.get('uniqueId')} className={'dialog-overlay'}>
                        <ContentComponent
                            id={dialog.get('id')}
                            type={dialog.get('type')}
                            uniqueId={dialog.get('uniqueId')}
                            settings={dialog.get('settings')}
                            loading={dialog.get('loading')}
                        />
                    </div>
                )
            })
            .toArray()
    }

    render() {
        const { dialogs } = this.props

        const content = !dialogs.isEmpty() ? this.renderDialogs() : null

        return ReactDOM.createPortal(content, dialogDiv)
    }
}
